// Extracted from .nvmrc
export const NODE_VERSION = "22.14.0";
